import r from'./../../ext-esm/style-inject/dist/style-inject.es.js';var e={root:"LoaderLinear_root__wqmu4"};r(".LoaderLinear_root__wqmu4.MuiLinearProgress-root{border-radius:2px;height:2px}");export{e as default};
